import { ScrollView as KeyboardAwareScrollView} from 'react-native'

export default KeyboardAwareScrollView